(() => {
  if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const running = new Map();
  const selector = '[data-hb-reveal]';
  const cancelWithin = (target) => {
    running.forEach((animation, element) => {
      if (element === target || element.contains(target) || target.contains(element)) animation.cancel();
    });
  };
  const observer = new IntersectionObserver(entries => {
    entries.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting) return;
      observer.unobserve(target);
      // Never animate an actively used card, disclosure, or link.
      if (preference.matches || target.contains(document.activeElement) || target.closest('a, button, details')?.contains(document.activeElement)) return;
      const kind = target.dataset.hbReveal;
      const index = [...target.parentElement.children].indexOf(target);
      const image = kind === 'image' ? target.querySelector('img') : null;
      if (kind === 'image' && !image) return;
      const subject = image || target;
      const baseline = getComputedStyle(subject).transform;
      const heading = kind === 'heading';
      const card = kind === 'card';
      const tilt = index % 2 === 0 ? -1.5 : 1.5;
      const frames = image
        ? [{ transform: 'scale(1.12)' }, { transform: baseline === 'none' ? 'scale(1)' : baseline }]
        : card
          ? [
              { transform: `translateY(32px) scale(.96) rotate(${tilt}deg)`, opacity: .35, offset: 0 },
              { transform: 'translateY(-4px) scale(1.008) rotate(0deg)', opacity: 1, offset: .75 },
              { transform: 'translateY(0) scale(1) rotate(0deg)', opacity: 1, offset: 1 }
            ]
          : [
              { transform: `translateY(${heading ? 32 : 20}px)`, opacity: .25 },
              { transform: 'translateY(0)', opacity: 1 }
            ];
      const animation = subject.animate(frames, {
        duration: image ? 800 : heading ? 650 : card ? 650 : 450,
        delay: card ? (index % 3) * 90 : kind === 'text' ? 100 : 0,
        easing: image || heading ? 'cubic-bezier(.16, 1, .3, 1)' : 'cubic-bezier(.22, .8, .3, 1)',
        fill: 'none'
      });
      running.set(target, animation);
      const clear = () => running.delete(target);
      animation.onfinish = clear;
      animation.oncancel = clear;
    });
  }, { threshold: .08 });
  const init = (root) => {
    const elements = [...root.querySelectorAll(selector)];
    if (root instanceof Element && root.matches(selector)) elements.unshift(root);
    elements.forEach(element => {
      if (seen.has(element)) return;
      seen.add(element);
      if (!preference.matches) observer.observe(element);
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(selector).forEach(element => observer.unobserve(element));
    cancelWithin(event.target);
  });
  document.addEventListener('focusin', event => cancelWithin(event.target));
  document.addEventListener('pointerdown', event => cancelWithin(event.target));
  preference.addEventListener('change', () => {
    if (preference.matches) {
      observer.disconnect();
      running.forEach(animation => animation.cancel());
    }
  });
})();
